<template>
    <div>
        <el-dialog
            title="房源详情"
            :visible.sync="showdialog"
            width="1200px"
            :before-close="back">
            <div class="base-warp">
                <el-form :model="houseInfo" ref="form" label-width="80px" :inline="false" size="mini" v-if="houseInfo">
                    <el-form-item label="编号">
                        <el-input v-model="houseInfo.id" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="房东">
                        <p class="text link-text" @click="tolandlord">姓名：{{landlordInfo.name}}，手机：{{landlordInfo.telephone}}</p>
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input v-model="houseInfo.name" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="户型" v-if="houseType">
                        <p class="text">{{houseType.room}}室{{houseType.hall}}厅{{houseType.kitchen}}厨{{houseType.toilet}}卫</p>
                    </el-form-item>
                    <el-form-item label="床位">
                        <el-input v-model="houseInfo.bed" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="面积">
                        <el-input v-model="houseInfo.area" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="所属分店">
                        <el-input v-model="houseInfo.region" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="地址">
                        <p class="text">地理位置：{{address.name}}</p>
                        <p class="text">详细信息：{{address.detail}}</p>
                    </el-form-item>
                    <el-form-item label="wifi">
                        <p class="text">账号：{{wifi.name}}</p>
                        <p class="text">密码：{{wifi.pwd}}</p>
                    </el-form-item>
                    <el-form-item label="关联设备" v-if="lock||emeter">
                        <el-row style="border-bottom:1px solid #999;padding:5px;" v-if="lock">
                            <el-col :span="4">门锁：</el-col>
                            <el-col :span="20">
                                <el-row v-for="(item,index) in lock" :key="item.id">
                                    <el-col :span="1" style="color:#E6A23C;">{{index+1}}</el-col>
                                    <el-col :span="23">
                                        <span class="eq-span"><b>MAC：</b>{{item.mac}}</span>
                                        <span class="eq-span el-waring" :class="{text_active: item.status}"><b>状态：</b>{{item['status']?item['status']:'查询中'}}</span>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-row style="padding:5px;" v-if="emeter">
                            <el-col :span="4">电表：</el-col>
                            <el-col :span="20">
                                <el-row v-for="(item,index) in emeter" :key="item.id">
                                    <el-col :span="1" style="color:#E6A23C;">{{index+1}}</el-col>
                                    <el-col :span="23">
                                        <span class="eq-span"><b>emCode：</b>{{item.mac}}</span>
                                        <span class="eq-span el-waring" :class="{text_active: item.status}"><b>状态：</b>{{item.status?item.status:'查询中'}}</span>
                                        <span class="eq-span el-waring" :class="{text_active: item.kwh}"><b>电量：</b>{{item.kwh?item.kwh:'查询中'}}</span>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="房间图片">
                        <el-image class="housePics" :src="item" v-for="item in cleanPics" :key="item"></el-image>
                    </el-form-item>
                </el-form>
                
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
import {formatPictureAddress} from '@/units/util';
export default {
    data() {
        return {
            showdialog: true,
            houseInfo: '',
            landlordInfo: '',
            houseType: '',
            wifi: false,
            emeter: false,
            lock: false,
            idcardPics: '',
            cleanPics: false,
            hid: '',
        }
    },
    mounted () {
        this.hid = this.$route.query.hid;
        this.getHouseInfo();
    },
    methods: {
        tolandlord() {
            var id = this.$Base64.encode(this.landlordInfo.id);
            this.$router.push({path: '/police/statics/landlord', query: {uid: id, type: 'landlord'}})
        },
        getHouseInfo() {
            var that = this;
            var params = {
                hid: this.hid,
            }
            this.$api.getHouseInfoById(params)
                .then(data=>{
                    if (data.houseInfo) {
                        that.houseInfo = data.houseInfo;
                        var bed = that.houseInfo.houseType.beds ? that.houseInfo.houseType.beds : 0;
                        that.address = that.houseInfo.address;
                        that.houseType = that.houseInfo.houseType;
                        that.houseInfo.bed = that.houseType.room + bed;
                        if (that.houseInfo.wifi) {
                            that.wifi = that.houseInfo.wifi;
                        }
                        if (data.houseInfo.cleanPics) {
                            var cleanPics = JSON.parse(data.houseInfo.cleanPics);
                            // console.log(cleanPics);
                            that.cleanPics = cleanPics.map((urls) => {
                                // console.log(urls);
                                return formatPictureAddress(urls);
                            });
                            // console.log(that.cleanPics);
                        }
                    }
                    if (data.landlordInfo) {
                        that.landlordInfo = data.landlordInfo;
                        if (that.landlordInfo.idcardPics) {
                            that.idcardPics = formatPictureAddress(that.landlordInfo.idcardPics[0]);
                        }
                    }
                    if (data.emeter.length !== 0) {
                        that.emeter = data.emeter;
                        that.getEmeterStatus();
                    }
                    if (data.lock.length !== 0) {
                        that.lock = data.lock;
                        that.getLockStatus();
                    }
                })
        },
        getLockStatus() {
            var params = {
                locks: this.lock,
            };
            this.$api.getLockStatusArr(params)
                .then(data=>{
                    if (data.lock_status) {
                        var status = data.lock_status.slice();
                        var locks = data.lock.slice();
                        for (var v1 of locks) {
                            for (var v2 of status) {
                                if (v1.mac === v2.mac) {
                                    if (v2.rssiStrong === 0) {
                                        v1.status = '离线';
                                    } else {
                                        v1.status = '在线';
                                    }
                                }
                            }
                        }
                        this.lock = locks;
                    }
                })
        },
        getEmeterStatus() {
            var params = {
                emeters: this.emeter,
            }
            this.$api.getEmeterStatusArr(params)
                .then(data=>{
                    if (data.emeter_status) {
                        var status = data.emeter_status.slice();
                        var emeters = that.emeter.slice();
                        for (var v1 of emeters) {
                            for (var v2 of status) {
                                if (v1.mac.toString() === v2.emCode.toString()) {
                                    if (v2.isOnline === 1) {
                                        v1.status = '在线';
                                    } else {
                                        v1.status = '离线';
                                    }
                                    v1.kwh = v2.enablekwh + 'kwh';
                                }
                            }
                        }
                        this.emeter = emeters;
                    }
                })
        },
        back() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang="scss" scoped>
.housePics{
    width: 300px;
}
</style>